import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { CONTACT, VALUES, PRODUCTS } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-forest-border bg-forest" data-testid="footer">
      <div className="pointer-events-none select-none px-6 pt-16 lg:px-10">
        <p className="text-center font-serif text-[16vw] leading-none text-white/[0.04] lg:text-[13vw]">
          NISHMAYY
        </p>
      </div>

      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4 lg:px-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Nishmayy Global logo" className="h-11 w-11 object-contain" />
            <span className="font-serif text-xl text-cream">
              Nishmayy <span className="text-gold">Global</span>
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-sage">
            Connecting India's strengths with global opportunities. Premium dry fruit processing and
            agro-commodity exports from New Delhi to the world.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold">Explore</h4>
          <ul className="mt-5 space-y-3 text-sm text-sage">
            <li><Link to="/" className="transition-colors hover:text-gold" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-gold" data-testid="footer-link-about">About Us</Link></li>
            <li><Link to="/products" className="transition-colors hover:text-gold" data-testid="footer-link-products">Commodity Portfolio</Link></li>
            <li><Link to="/dryveda" className="transition-colors hover:text-gold" data-testid="footer-link-dryveda">DryVeda Brand</Link></li>
            <li><Link to="/export-logistics" className="transition-colors hover:text-gold" data-testid="footer-link-export">Export & Logistics</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-gold" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold">Portfolio</h4>
          <ul className="mt-5 space-y-3 text-sm text-sage">
            {PRODUCTS.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link to="/products" className="transition-colors hover:text-gold" data-testid={`footer-product-${p.slug}`}>
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold">Reach Us</h4>
          <ul className="mt-5 space-y-4 text-sm text-sage">
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-gold" />
              <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-gold" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 shrink-0 text-gold" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-forest-border">
        <p className="px-6 py-5 text-center text-[11px] tracking-[0.3em] text-sage/70" data-testid="footer-values">
          {VALUES.join("  |  ")}
        </p>
      </div>
      <div className="border-t border-forest-border">
        <p className="px-6 py-5 text-center text-xs text-sage/60" data-testid="footer-legal">
          © {new Date().getFullYear()} Nishmayy Global OPC Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
